import _ from 'lodash'
import TimeSlotAdapter from './time-slot-adapter'

function getOverlaps(timeSlots) {
    timeSlots = _.filter(timeSlots, (timeSlot) => timeSlot.isValid());

    timeSlots = _.map(timeSlots, (timeSlot) => {
        const collection = timeSlot.isExpandable() ? timeSlot.expand() : Array(timeSlot);
        return collection.map((timeSlot) => timeSlot.rangeMinutesFromStartOfWeek());
    });

    return _.map(timeSlots, (timeSlot) => {
        return _.reduce(_.without(timeSlots, timeSlot), (carry, timeSlotToCompare) => {
            const overlapped = _.reduce(timeSlot, (carry, ts) => {
                return carry || checkForOverlaps(ts, timeSlotToCompare);
            }, false);

            return overlapped ? carry + 1 : carry;
        }, 0);
    });
}

function checkForOverlaps (timeSlot, timeSlotsToCompare) {
    return _.reduce(timeSlotsToCompare, (carry, timeSlotToCompare) => {
        return carry || hasOverlap(timeSlot, timeSlotToCompare);
    }, false);
};

function hasOverlap(timeSlotOne, timeSlotTwo) {
    return (timeSlotOne.startTime > timeSlotTwo.startTime && timeSlotOne.startTime < timeSlotTwo.endTime) ||
        (timeSlotOne.startTime <= timeSlotTwo.startTime && timeSlotOne.endTime >= timeSlotTwo.endTime) ||
        (timeSlotOne.endTime > timeSlotTwo.startTime && timeSlotOne.endTime < timeSlotTwo.endTime);
}

export default {
    getOverlaps
}
